import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_SAAS_PROD } from "../consts.js"

export const tokiomarine = {
	"tokiomarine-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_PROD }
}
